export default __webpack_public_path__ + "static/media/edit.3508776b.svg";